import React from 'react';
import { useTranslation } from 'react-i18next';
import './guide-video-modal.scss';

interface GuideVideoModalProps {
  show: boolean;
  onClose: () => void;
  videoUrl: string;
  title?: string;
}

// Reusable "watch a guide" video modal — same look/behaviour as the invoice tool's
// header guide video (dark themed player, gradient title bar, autoplay with controls).
const GuideVideoModal: React.FC<GuideVideoModalProps> = ({ show, onClose, videoUrl, title }) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <div className="gvm-overlay" onClick={onClose}>
      <div className="gvm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="gvm-modal__head">
          <h3 className="gvm-modal__title">{title || ''}</h3>
          <button
            type="button"
            className="gvm-modal__close"
            onClick={onClose}
            aria-label={(t('CLOSE') as string) || 'Close'}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </button>
        </div>
        <div className="gvm-modal__video-wrap">
          <video
            key={videoUrl}
            className="gvm-modal__video"
            src={videoUrl}
            controls
            autoPlay
            playsInline
            controlsList="nodownload"
          />
        </div>
      </div>
    </div>
  );
};

export default GuideVideoModal;
